import { useResetRecoilState } from "recoil";
import { useResetAtom } from "jotai/utils";
import { allProductPropertiesState, authState, organizationState, planDetailsState, userFeaturesPermissionsState, userState } from "../atoms";
import { useCallback } from "react";
import { coreLogout } from "../utils/coreLogout";


export default function useLogout(redirectTo) {

    //---global states---
    //--recoil
    const resetOrganization = useResetRecoilState(organizationState);
    const resetUser = useResetRecoilState(userState);
    const resetPlanDetails = useResetRecoilState(planDetailsState);

    //--jotai
    const resetAuthState = useResetAtom(authState);
    const resetAllProductPropertiesState = useResetAtom(allProductPropertiesState)
    const resetUserFeaturesPermissions = useResetAtom(userFeaturesPermissionsState);

    const logout = useCallback(async () => {
        const isLogoutSuccess = await coreLogout();

        if (isLogoutSuccess) {
            resetOrganization();
            resetUser();
            resetPlanDetails();
            resetAuthState();
            resetAllProductPropertiesState()
            resetUserFeaturesPermissions()

            if (redirectTo) {
                window.location.href = redirectTo;
            }
        }

    }, [resetAllProductPropertiesState, resetAuthState, resetOrganization, resetPlanDetails, resetUser, resetUserFeaturesPermissions, redirectTo])

    return logout
}